module.exports = __webpack_public_path__ + "static/media/desktopScreenshot04.0c476d10.jpg";